import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Sets an httpOnly session cookie server-side; response body is ignored.
      await api.post("/admin/login", { email, password });
      toast.success("Welcome back");
      nav("/admin");
    } catch {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] grid place-items-center px-6" data-testid="page-admin-login">
      <SEO title="Admin login" path="/admin/login" />
      <form onSubmit={submit} className="w-full max-w-sm bg-[#F5F5F7] rounded-3xl p-8 space-y-4">
        <p className="eyebrow">Admin</p>
        <h1 className="text-h3">Sign in</h1>
        <div>
          <label className="text-sm">Email</label>
          <input required type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" className="mt-2 w-full h-12 px-4 rounded-xl bg-white focus:ring-1 focus:ring-[#0066FF] focus:outline-none" />
        </div>
        <div>
          <label className="text-sm">Password</label>
          <input required type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" className="mt-2 w-full h-12 px-4 rounded-xl bg-white focus:ring-1 focus:ring-[#0066FF] focus:outline-none" />
        </div>
        <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="admin-login-submit">{loading ? "Signing in..." : "Sign in"}</button>
        <div className="text-center pt-2">
          <Link to="/admin/forgot-password" className="text-sm text-[#0066FF]" data-testid="admin-forgot-link">Forgot password?</Link>
        </div>
      </form>
    </div>
  );
}
